export enum ChangeHistoryEvents {
  CREATED = 'CREATED',
  VERIFIED = 'VERIFIED',
  UNVERIFIED = 'UNVERIFIED',
  BLOCKED = 'BLOCKED',
  UNBLOCKED = 'UNBLOCKED',
  SECOND_INVITATION_SENT = 'SECOND_INVITATION_SENT',
}
